module.exports = __webpack_public_path__ + "img/joinus.2fa0dd9e.png";